var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaccination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 7.69238L6.23177 15.0935C5.92526 15.3997 5.68209 15.7632 5.51619 16.1635C5.35029 16.5637 5.26489 16.9927 5.26489 17.4259C5.26489 17.8591 5.35029 18.2881 5.51619 18.6883C5.68209 19.0886 5.92526 19.4521 6.23177 19.7583L8.3087 21.8352C8.61487 22.1418 8.97846 22.3849 9.37867 22.5508C9.77889 22.7167 10.2079 22.8021 10.6411 22.8021C11.0744 22.8021 11.5033 22.7167 11.9036 22.5508C12.3038 22.3849 12.6674 22.1418 12.9735 21.8352L20.3746 14.2858",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5504 3.57129L24.4955 8.51634",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0779 10.989L22.0229 6.04395",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27019 20.7969L3.06689 25.0002",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3086 5.21973L22.8471 16.7582",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccination);
export default __webpack_public_path__ + "static/media/vaccination.a0ba02856cd0fb00045d7c8a8d4f3086.svg";
export { ForwardRef as ReactComponent };